export const getNotificationDetailTargetId = (
  pathname: string,
  searchParams: Pick<URLSearchParams, 'get'>,
): string | null => {
  if (pathname === '/home') {
    const activity = searchParams.get('activity');
    const [, entityId] = activity?.split(':') ?? [];
    return entityId || null;
  }

  const detailPaths = new Set([
    '/plans/detail',
    '/co-actions/detail',
    '/completion-reports/detail',
    '/post-mortems/detail',
    '/conventions/detail',
    '/code-reviews/detail',
    '/documents/detail',
  ]);

  return detailPaths.has(pathname) ? qp.id().parse(searchParams.get('id')) : null;
};

export type NotificationTargetReadAction = 'WAIT' | 'SKIP_AND_MARK_HANDLED' | 'MUTATE_AND_MARK_HANDLED';

type NotificationTargetReadActionInput = {
  entityId: string | null;
  isHandled: boolean;
  unreadCount: number | undefined;
  isUnreadCountSuccess: boolean;
  isUnreadCountError: boolean;
};

export const getNotificationTargetReadAction = ({
  entityId,
  isHandled,
  unreadCount,
  isUnreadCountSuccess,
  isUnreadCountError,
}: NotificationTargetReadActionInput): NotificationTargetReadAction => {
  if (!entityId || isHandled) return 'WAIT';
  if (isUnreadCountError) return 'MUTATE_AND_MARK_HANDLED';
  if (!isUnreadCountSuccess) return 'WAIT';

  return unreadCount === 0 ? 'SKIP_AND_MARK_HANDLED' : 'MUTATE_AND_MARK_HANDLED';
};
import { qp } from '../qp';
